/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const openPositionMembershipCreateRestRequestSchema = z.object({
  commitment: z.number().min(0).max(1).nullish(),
  endDate: z.iso.date().nullish(),
  openPositionId: z.int(),
  roleId: z.int(),
  startDate: z.iso.date().nullish(),
});
